import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable()
export class PopoverService {
  private state: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private positionState: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  getState(): Observable<boolean> {
    return this.state.asObservable();
  }

  getPositionState(): Observable<boolean> {
    return this.positionState.asObservable();
  }

  close() {
    return this.state.next(true);
  }

  recalculatePosition() {
    return this.positionState.next(true);
  }
}
